import * as React from 'react';

import { SpellName as CommonSpellName } from '@dndbeyond/character-common-components/es';
import {
    SpellUtils,
    EntityUtils,
    FormatUtils,
    BaseSpell,
    DataOriginRefData,
    CharacterTheme,
} from '@dndbeyond/character-rules-engine/es';

import { ConcentrationIcon, RitualIcon } from '../Icons';

interface Props {
    spell: BaseSpell;
    onClick?: (spell: BaseSpell) => void;
    showSpellLevel: boolean;
    showExpandedType: boolean;
    className: string;
    dataOriginRefData: DataOriginRefData;
    theme?: CharacterTheme;
}
export default class SpellName extends React.PureComponent<Props> {
    static defaultProps = {
        showSpellLevel: true,
        showExpandedType: false,
        className: '',
    };

    handleClick = (): void => {
        const { onClick, spell } = this.props;

        if (onClick) {
            onClick(spell);
        }
    };

    getExpandedInfoText = (): string | null => {
        const { spell, dataOriginRefData } = this.props;

        let expandedDataOriginRef = SpellUtils.getExpandedDataOriginRef(spell);
        if (expandedDataOriginRef === null) {
            return null;
        }

        return EntityUtils.getDataOriginRefName(expandedDataOriginRef, dataOriginRefData);
    };

    render() {
        const { spell, showSpellLevel, className, onClick, showExpandedType, theme } = this.props;

        return (
            <CommonSpellName
                className={className}
                onClick={onClick ? this.handleClick : undefined}
                showExpandedType={showExpandedType}
                expandedTypeText={this.getExpandedInfoText()}
                name={SpellUtils.getName(spell)}
                isCustomized={SpellUtils.isCustomized(spell)}
                showIcons={true}
                isConcentration={SpellUtils.getConcentration(spell)}
                isRitual={SpellUtils.isRitual(spell)}
                showSpellLevel={showSpellLevel}
                isDarkMode={theme?.isDarkMode}
                concentrationIcon={
                    <ConcentrationIcon
                        className="ddbc-spell-name__icon"
                        themeMode={theme?.isDarkMode ? 'gray' : 'dark'}
                    />
                }
                ritualIcon={
                    <RitualIcon className="ddbc-spell-name__icon" themeMode={theme?.isDarkMode ? 'gray' : 'dark'} />
                }
                level={FormatUtils.renderSpellLevelShortName(SpellUtils.getLevel(spell))}
            />
        );
    }
}
